export default __webpack_public_path__ + "static/media/icon-change-photo.4347a5b9.svg";